var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTagCheckOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".st0 {fill: #1c4ec1;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "path",
    className: "st0",
    points: "8.8 20.8 .8 12.8 3.6 10 8.8 15.2 20.4 3.5 23.2 6.3 8.8 20.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTagCheckOn);
export default __webpack_public_path__ + "static/media/ico_tag_check_on.c9cf2e3b1aad2901f4d05e7d61a77d80.svg";
export { ForwardRef as ReactComponent };